/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyControlPanelAutoPrinterTypename = "PharmacyControlPanelAutoPrinter" as const;

/**
 *
 * @export
 * @interface PharmacyControlPanelAutoPrinter
 */
export interface PharmacyControlPanelAutoPrinter {
  /**
   *
   * @type {string}
   * @memberof PharmacyControlPanelAutoPrinter
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyControlPanelAutoPrinter
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyControlPanelAutoPrinter
   */
  url?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyControlPanelAutoPrinter
   */
  readonly __typename?: string;
}

export function PharmacyControlPanelAutoPrinterFromJSON(json: any): PharmacyControlPanelAutoPrinter {
  return PharmacyControlPanelAutoPrinterFromJSONTyped(json, false);
}

export function PharmacyControlPanelAutoPrinterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyControlPanelAutoPrinter {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyControlPanelAutoPrinterTypename,

    name: !exists(json, "name") ? undefined : json["name"],
    type: !exists(json, "type") ? undefined : json["type"],
    url: !exists(json, "url") ? undefined : json["url"],
  };
}

export function PharmacyControlPanelAutoPrinterToJSON(object?: PharmacyControlPanelAutoPrinter | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    name: value.name,
    type: value.type,
    url: value.url,
  };
}
